import { render, staticRenderFns } from "./CommunityGameCard.vue?vue&type=template&id=aef8419c&"
import script from "./CommunityGameCard.vue?vue&type=script&lang=js&"
export * from "./CommunityGameCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityGameCard.vue?vue&type=style&index=0&id=aef8419c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports